var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "branch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 8c-1.804 0.007-3.325 1.208-3.814 2.854l-0.007 0.028h-12.358c-0.5-1.679-2.030-2.882-3.841-2.882-2.209 0-4 1.791-4 4s1.791 4 4 4c1.811 0 3.34-1.203 3.833-2.854l0.007-0.028h0.179c1.59 0 2.883 1.741 2.883 3.882-0.012 0.136-0.018 0.294-0.018 0.454 0 2.947 2.241 5.371 5.111 5.662l0.024 0.002h0.178c0.5 1.679 2.030 2.883 3.841 2.883 2.209 0 4-1.791 4-4s-1.791-4-4-4c-1.811 0-3.341 1.204-3.834 2.855l-0.007 0.028h-0.178c-1.59 0-2.883-1.742-2.883-3.883 0-0.009 0-0.020 0-0.031 0-1.439-0.447-2.774-1.21-3.873l0.015 0.022h8.257c0.503 1.67 2.026 2.865 3.829 2.865 2.205 0 3.992-1.787 3.992-3.992s-1.787-3.992-3.992-3.992c-0.003 0-0.006 0-0.009 0h0zM22 20c1.105 0 2 0.895 2 2s-0.895 2-2 2c-1.105 0-2-0.895-2-2v0c0-1.105 0.895-2 2-2v0zM6 14c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2v0zM26 14c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2v0c0 1.105-0.895 2-2 2v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityBranch);
export default __webpack_public_path__ + "static/media/unity_branch.ecaf08a12c00587bd273c7020f0f31a2.svg";
export { ForwardRef as ReactComponent };